export default {
  nav: {
    home: '首頁',
    services: '产品服務',
    solutions: '解決方案',
    cases: '案例中心',
    partners: '合作夥伴',
    news: '公司動態',
    contact: '聯繫我們',
    smb: 'SMB 服務',
    logo: '點一雲科技'
  },
  hero: {
    title: '全球領先的雲服務提供商',
    company: '點一雲科技',
    subtitle: '通過技術創新和資源整合，為企業提供全方位的雲服務解決方案，助力客戶在AI時代實現全球業務拓展。',
    learnMore: '了解更多',
    contactUs: '聯繫我們',
    stats: {
      countries: '國家地區',
      availability: '服務可用性'
    },
    partners: {
      alt: '合作夥伴'
    }
  },
  services: {
    title: '產品服務',
    subtitle: '為企業提供全方位的雲服務解決方案',
    items: {
      cloud: {
        title: '公有雲代理',
        desc: '提供穩定、高效、安全的雲計算服務，快速開戶，7*24小時技術支持'
      },
      gpu: {
        title: 'GPU算力服務',
        desc: '專為AI訓練、深度學習等場景打造的高性能GPU雲主機'
      },
      ai: {
        title: 'AI海外矩陣營銷',
        desc: '一站式解決方案：雲手機 + 自動化機器人 + AIGC'
      },
      edge: {
        title: '邊緣計算',
        desc: '200+全球邊緣節點，提供高效的跨境網絡服務'
      },
      security: {
        title: '人工智能應用',
        desc: '高效處理海量數據和複雜模型，為AI應用提供強大的計算能力和資源'
      },
      sms: {
        title: '國際營銷短信服務',
        desc: '覆蓋全球230個國家和地區，支持多語言，幫助企業簡單、快速、低成本地拓展海外市場'
      }
    }
  },
  solutions: {
    title: '解決方案',
    subtitle: '為您的業務提供全方位的技術支持',
    items: {
      crossBorder: {
        title: '一站式出海解決方案',
        desc: '為企業提供完整的跨境業務平台，包含市場調研、策略規劃、運營管理等全方位服務'
      },
      sms: {
        title: '國際營銷短信服務',
        desc: '提供全球覆蓋的短信發送服務，支持多語言、高到達率、快速穩定'
      },
      ddos: {
        title: '高防DDoS解決方案',
        desc: '提供強大的DDoS防護能力，保護您的業務免受各類網絡攻擊的威脅'
      },
      acceleration: {
        title: '跨境加速安全解決方案',
        desc: '通過全球節點網絡，為您的跨境業務提供安全、穩定、高速的網絡加速服務'
      }
    }
  },
  cases: {
    title: '案例中心',
    subtitle: '探索我們的成功案例，了解如何為客戶創造價值',
    viewDetails: '查看詳情',
    cards: {
      fengrui: {
        title: '廣西鋒銳信息技術服務有限公司上雲成功案例',
        desc: '幫助企業完成 AWS 雲遷移，提升系統性能，降低運維成本'
      },
      bairui: {
        title: '武漢柏銳科技有限公司上雲成功案例',
        desc: '為遊戲公司提供高性能雲託管服務，支持全球玩家同時在線'
      },
      inventoryGame: {
        title: '某企業庫存管理系統上雲成功案例',
        desc: '為庫存管理系統提供穩定可靠的雲服務，提升用戶體驗'
      },
      inventoryStable: {
        title: '某企業數據管理系統上雲成功案例',
        desc: '為企業提供強大的計算和存儲資源，提高數據處理能力'
      }
    },
    items: {
      crossBorder: {
        title: '跨境電商解決方案',
        desc: '為某知名跨境電商平台提供一站式出海解決方案，包括支付系統、物流對接、多語言支持等，幫助客戶快速拓展海外市場。',
        tags: {
          ecommerce: '跨境電商',
          payment: '支付系統',
          multilingual: '多語言'
        }
      },
      ddos: {
        title: '高防DDoS防護方案',
        desc: '為某遊戲公司提供高防DDoS解決方案，通過智能防護系統有效抵禦各類網絡攻擊，確保遊戲服務器穩定運行。',
        tags: {
          protection: 'DDoS防護',
          gameserver: '遊戲服務器',
          security: '網絡安全'
        }
      }
    },
    backToHome: '返回首頁'
  },
  news: {
    title: '公司動態',
    subtitle: '了解我們的最新發展',
    content: {
      paragraph1: '香港點一雲科技有限公司是華為雲、騰訊雲、阿里雲、亞馬遜雲等雲廠科技核心級服務合作夥伴，致力於為客戶提供雲運維託管、成本管理、架構諮詢、雲遷移、數據庫等服務，覆蓋遊戲、音視頻直播、WEB3、零售電商、AI智能、新能源等行業。始終為客戶提供可信賴的雲上服務與解決方案，通過與各大雲原廠的技術深度集成，為客戶提供音視頻直播、WEB3區塊鏈生態、現代AI智能分析、遊戲託管運維、電商服務、內容審核等多行業解決方案，並將持續探索雲計算創新雲改革，為客戶提供更全面、高效、安全的雲服務，助力其在數字化時代取得成功。',
      paragraph2: '點一雲總部位於香港，在迪拜、深圳設有分公司，現有團隊已有50+人，公司具有AWS、騰訊雲、華為雲等專業認證。成員均為在IT互聯網行業服務三年以上，擁有豐富的技術以及經驗。'
    }
  },
  partners: {
    title: '合作夥伴',
    items: {
      partner1: '華為雲',
      partner2: '騰訊雲',
      partner3: '阿里雲',
      partner4: '亞馬遜雲',
      partner5: '微軟雲',
      partner6: '谷歌雲'
    }
  },
  contact: {
    title: '聯繫我們',
    subtitle: '隨時為您提供專業服務',
    email: {
      title: '郵箱',
      value: 'san@dycloud.ai'
    },
    phone: {
      title: '電話',
      value: '15989283653 劉先生'
    },
    wechat: {
      title: '微信',
      qrcode: '微信二維碼',
      scan: '掃碼添加微信'
    },
    copyright: '© 2024 香港點一雲科技有限公司. All rights reserved.'
  }
} 